import { colors, space, radius } from "../../design/tokens";

export default function Content({ children, style }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        maxWidth: "720px",
        margin: "0 auto",
        padding: space.lg,
        ...style,
      }}
    >
      {children}
    </div>
  );
}